export default "__VITE_ASSET__Ab$vEuT8__"